var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-blank"},[_vm._v("分割留白（高度"+_vm._s(_vm.unitData.height || '20')+"）")])
}
var staticRenderFns = []

export { render, staticRenderFns }